{ Analytics } = require '@trello/atlassian-analytics'
Board = require 'app/scripts/models/board'
CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
{ featureFlagClient } = require '@trello/feature-flag-client'
Util = require 'app/scripts/lib/util'
{ trackUe, Noun, Verb } = require '@trello/analytics'

class BoardList extends CollectionWithHelpers
  model: Board

  initialize: ->
    @comparatorCache = {}
    @listenTo @, 'change:name change:idOrganization', =>
      @comparatorCache = {}
      @sort

    return

  comparator: (board) ->
    boardId = board.id
    ret = @comparatorCache[boardId]
    if !ret
      # Sort by org name, then board name
      org = board.getOrganization()
      orgName = org?.get('displayName') || ""
      boardName = board.get('name') || ""
      ret = @comparatorCache[boardId] = Util.rpad(orgName, 64).toUpperCase() + boardName.toUpperCase()

    ret

  create: (attrs) ->
    if featureFlagClient.get('remarkable.track-bc-features', false)
      idOrg = attrs.idOrganization
      if idOrg
        trackUe
          category: Noun.BUSINESS_CLASS_FEATURE
          verb: Verb.CREATES
          directObj: Noun.BOARD
          context:
            organizationId: idOrg
            requiredBC: false

    super



module.exports = BoardList
